import { Component, ViewChild, ChangeDetectorRef } from '@angular/core';

import {
  PerfectScrollbarDirective,
  PerfectScrollbarConfigInterface,
} from 'ngx-perfect-scrollbar';
import { Config } from '../config';
import { MatSpinner } from '@angular/material/progress-spinner';
import { MatSidenav } from '@angular/material/sidenav';
import { MediaMatcher } from '@angular/cdk/layout';
import { DewAuthService } from 'src/authentication/core/auth.service';
import { ApiService } from '@app/services/api.services';

@Component({
  selector: 'dew-layout',
  templateUrl: './dew-layout.component.html',
})
export class DewLayoutComponent {
  @ViewChild(MatSidenav, { static: false }) dewsidenav: MatSidenav;

  public matSpinner = MatSpinner;
  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;
  navigationData: any = [];
  isExpandedMenu: boolean = false;
  clientLogoUrl: string;
  clientDomainName: string;

  closeSideNav() {
    this.dewsidenav.close();
  }

  constructor(
    public authService: DewAuthService,
    public api: ApiService,
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher
  ) {
    this.mobileQuery = media.matchMedia('(max-width: 960px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }

  @ViewChild(PerfectScrollbarDirective, { static: false })
  directiveScroll: PerfectScrollbarDirective;

  public config: PerfectScrollbarConfigInterface = {};

  project = {
    name: Config.projectName,
    logo: Config.projectLogoUrl,
    navigationType: Config.navigationType,
  };

  ngOnInit() {
    this.getNavigationData();
    this.getSubDomainDetails();

  }

  getSubDomainDetails() {
    const fullUrl = 'app.yaujana.com'; //window.location.host;
    const parts = fullUrl.split('.');
    if (parts && parts.length === 3) {
      let subdomain = parts[0];
      const domain = parts[1];
      const type = parts[2];
      subdomain = subdomain.toLowerCase();
      if (subdomain !== 'www' && subdomain !== '' && subdomain !== 'app') {
        this.clientDomainName = subdomain;
        this.getClientDomainLogo();
      } else {
        this.clientLogoUrl = '../../assets/img/yojna_logo_new.png';

      }
    } else {
      this.clientLogoUrl = '../../assets/img/yojna_logo_new.png';

    }
    

    // this.clientDomainName = 'pro';
    // this.getClientDomainLogo();
    // this.setDefaultTheme();
  }

  getClientDomainLogo() {
    this.api.getMasterClientLogoByDomainName(this.clientDomainName).subscribe((res) => {
      if (res && res.response && res.response[0].docId) {
        let docId = res.response[0].docId;
        let url = Config.ServiceBaseUrl;
        this.clientLogoUrl = url + 'api/downloadFile?DocId=' + docId;
      }
      else {
        this.clientLogoUrl = '../../assets/img/yojna_logo_new.png';
      }
    });
  }
  getNavigationData() {
    this.navigationData = [
      {
        routeName: 'Schedule',
        routerLink: '/schedule',
        icon: 'watch_later',
        permission: '"schedulemenu :: read"',
      },
      {
        routeName: 'Project Gantt',
        routerLink: '/project-gantt',
        icon: 'event_note',
        permission: '"projectganttmenu :: read"',
      },
      {
        routeName: 'Clients',
        routerLink: '/client',
        icon: 'person',
        permission: '"clientmenu :: read"',
      },
      {
        routeName: 'Projects',
        routerLink: '/project',
        icon: 'file_copy',
        permission: '"projectmenu :: read"',
      },
      {
        routeName: 'Report',
        routerLink: '/report',
        icon: 'summarize',
        permission: '"reportmenu :: read"',
      },
      {
        routeName: 'Resources',
        routerLink: '/resources',
        icon: 'people',
        permission: '"peoplemenu :: read"',
      },
      {
        routeName: 'Team',
        routerLink: '/team',
        icon: 'business_center',
        permission: '"departmentmenu :: read"',
      },
      {
        routeName: 'Designations',
        routerLink: '/designation',
        icon: 'work',
        permission: '"designationmenu :: read"',
      },
      {
        routeName: 'Admin',
        routerLink: '/manage',
        icon: 'account_circle',
        permission: '"adminmenu :: read"',
      },
    ];
  }

  toggleMenuBar() {
    this.isExpandedMenu = !this.isExpandedMenu;
  }

  onLogout() {
    this.authService.logout();
  }
  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }
}
